import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <path d='M4.5 13.188H10.812H13.188H19.5V10.812H13.188H10.812H4.5V13.188Z' />
  </>,
  'Minus'
)
